"use client";

import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { LazyFontLoader } from "@/components/LazyFontLoader";
import { GoGlobal } from "./second-goglobal";
import { FirstScreen } from "./firstPage";
import { SecondPage } from "./secondPage";
import { ThirdPage } from "./thirdPage";
import { FifthPage } from "./fifthPage";
import { SixthPage } from "./sixthPage";
import { SeventhPage } from "./seventhPage";
import { Footer } from "@/components/footer";

// Lightweight skeleton components for initial render
// const FirstScreenSkeleton = () => (
//   <div className="w-full h-screen bg-gradient-to-br from-sky-200 to-purple-100 relative z-[1] flex flex-col">
//     <div className="w-full h-screen pt-[11rem] pl-[12rem] pr-[10vw] z-[3] pb-2.5 absolute flex">
//       <div className="flex-1">
//         <div className="text-[#0182FF] text-[3.125rem] font-extrabold leading-[6.25rem]">
//           一站式出海
//         </div>
//         <div className="text-[#333] text-[2.8125rem] font-bold">
//           网络解决方案引领者 赋能品牌出海新纪元
//         </div>
//         <div className="mt-[1.4375rem] flex w-[27rem] py-2.5 justify-center items-center gap-2.5 rounded-[3.125rem] bg-[rgba(0,129,255,0.60)] shadow-[0_0.25rem_0.625rem_0_rgba(0,0,0,0.10)]">
//           <span className="text-white text-center text-[1.5rem] font-medium leading-normal">
//             助力企业光速出海 成就全球无界时代
//           </span>
//         </div>
//       </div>
//       <div className="w-[37.75rem] h-[37.75rem] top-[-5rem] relative flex items-center justify-center">
//         <div className="w-[37.75rem] h-[37.75rem] bg-blue-100 rounded-full animate-pulse" />
//       </div>
//     </div>
//     <div className="flex-1" />
//     <div className="h-[30px]" />
//   </div>
// );

// const SecondPageSkeleton = () => (
//   <div className="w-[1920px] py-[72px] overflow-hidden pl-[13rem] pr-[15rem]">
//     <div className="w-[full] text-[#0F2B5B] text-center font-['Alibaba_PuHuiTi_3.0'] text-[3.125rem] font-bold">
//       打破跨境壁垒 让全球生意畅通无阻
//     </div>
//     <div className="w-full text-[rgba(51,51,51,0.50)] font-['Alibaba_PuHuiTi_3.0'] text-[1.5rem] font-light tracking-[4.4px] uppercase text-center">
//       Breaking down cross-border barriers ensures smooth global business
//     </div>
//     <div className="w-full flex gap-[1.3vw] mt-[165px] justify-center px-[auto]">
//       <div className="w-[22rem] h-[400px] bg-gradient-to-b from-[#DFE5FE] to-[#5A8BFE] rounded-lg animate-pulse" />
//       <div className="w-[22rem] h-[400px] bg-gradient-to-b from-[#C3F3FB] to-[#2CADE8] rounded-lg animate-pulse" />
//       <div className="w-[22rem] h-[400px] bg-gradient-to-b from-[#F0E5FF] to-[#8B5CF6] rounded-lg animate-pulse" />
//     </div>
//   </div>
// );

export default function HomeClient() {
  return (
    <AutofitPageWrapper>
      <FirstScreen />
      <SecondPage />
      <GoGlobal />
      <ThirdPage />
      <FifthPage />
      <SixthPage />
      <SeventhPage />
      <Footer />
      <LazyFontLoader />
    </AutofitPageWrapper>
  );
}
